module.exports = __webpack_public_path__ + "img/mssymbol.0660149a.svg";